"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createConsoleLogApi = createConsoleLogApi;
exports.createNoopLogApi = createNoopLogApi;
/**
 * Contains the subset of Pino (Fastify's logging module) we might use. We can
 * add more things from https://github.com/pinojs/pino/blob/master/docs/api.md
 * as needed.
 */

/**
 * Create a dummy LogApi implementation that does nothing.
 *
 * If a function optionally accepts a LogApi instance, this is a very
 * convenient default value.
 */
function createNoopLogApi() {
  return {
    trace(..._args) {},
    debug(..._args) {},
    info(..._args) {},
    warn(..._args) {},
    error(..._args) {},
    fatal(..._args) {},
    child() {
      return createNoopLogApi();
    }
  };
}

/**
 * Create a dummy LogApi implementation using the console global.
 */
function createConsoleLogApi(base = {}) {
  return {
    trace(...args) {
      console.log(base, ...args);
    },
    debug(...args) {
      console.log(base, ...args);
    },
    info(...args) {
      console.log(base, ...args);
    },
    warn(...args) {
      console.error(base, ...args);
    },
    error(...args) {
      console.error(base, ...args);
    },
    fatal(...args) {
      console.error(base, ...args);
    },
    child(newBase) {
      return createConsoleLogApi({
        ...base,
        ...(newBase || {})
      });
    }
  };
}
//# sourceMappingURL=LogApi.js.map